module.exports = __webpack_public_path__ + "static/media/IMG_0022.82fc3b85.JPG";